export const ESTATUS = {
  PENDING: "pending",
  PUBLICADA: "publicada",
  INACTIVA: "inactiva",
};